const initialState = {
  status: 'default',
  options: [],
};

export default function (
  state = initialState,
  action = {
    type: '',
    options: [],
  }
) {
  switch (action.type) {
    case 'GET_BANKS':
      return {
        ...state,
        status: 'loading',
      };

    case 'GET_BANKS_RESPONSE':
      return {
        ...state,
        options: action.options,
        banksStatus: 'loaded',
      };

    default:
      return state;
  }
}
